module.exports = __webpack_public_path__ + "img/om.21a2e047.svg";